export default __webpack_public_path__ + "static/media/template-article.8d785432.jpg";